<template>
  <Home v-if="templateStyle == 'homepage'" :api-url="apiUrl" ref="HomeRecommendedList"></Home>
  <Detail v-else-if="templateStyle == 'detailpage'" :api-url="apiUrl" ref="DetailRecommendedList"></Detail>
</template>

<script>
import Home from "./RecommendTemplates/Home";
import Detail from "./RecommendTemplates/Detail";

export default {
  components: {
    Home,
    Detail
  },
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    templateStyle: {
      type: String,
      required: true
    }
  }
};
</script>